import {
  GridActionsCellItem,
  GridColDef,
  GridColumns,
  GridRenderCellParams,
  GridRowParams,
  GridValueFormatterParams
} from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import { currencyFormatter } from 'helpers/currency-formatter';
import { filterOperators, numberFilterOperators } from '../../../../constants';
import EditIcon from '@mui/icons-material/Edit';
import DataGridCell from 'components/common/DataGridCell';
import { currencyCell } from '../cells/currency-cell';
import productStatusCell from '../cells/product-status-cell';
import ConfirmationDeleteTableDialog from 'components/helpers/ConfirmationGridDelete';

export function ContractLinesColumns(
  refresh: any,
  handleEdit?: (row: any) => void,
  handleManualDelete?: (id: number) => void,
  disableEdit?: boolean
): GridColDef[] {
  const { t } = useTranslation();
  const translationPrefix = 'entities.movement';

  const columns: GridColumns | any[] = [
    {
      field: 'product',
      headerName: t(`global.product`),
      width: 100,
      valueGetter: (params) => params.row.product.code
    },
    {
      field: 'product_description',
      headerName: t(`global.product_description`),
      width: 250,
      valueGetter: (params) => params.row.product.description
    },
    {
      field: 'status',
      headerName: t(`global.status`),
      width: 120,
      filterOperators,
      valueGetter: (params) => params.row.status,
      renderCell: productStatusCell(t)
    },
    {
      field: 'unit_price',
      headerName: t(`entities.contract_line.unit_price`),
      width: 120,
      align: 'center',
      //editable: true,
      filterOperators: numberFilterOperators,
      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value, { significantDigits: 3 });
      },
      renderCell: (params: GridRenderCellParams) => currencyCell(params, 3)
    },
    // {
    //   field: 'iva',
    //   headerName: t(`entities.contract_line.iva`),
    //   width: 100,
    //   filterable: false,
    //   align: 'center',
    //   filterOperators: numberFilterOperators,
    //   valueGetter: (params) => params.row.iva,
    //   renderCell: baseCell
    // },
    {
      field: 'initial_available_units',
      headerName: t(`entities.contract_line.initial_available_units`),
      width: 120,
      align: 'center',
      filterOperators: numberFilterOperators,
      //editable: true,
      renderCell: baseCell
    },
    {
      field: 'available_units',
      headerName: t(`entities.contract_line.available_units`),
      filterOperators: numberFilterOperators,
      align: 'center',
      width: 120,
      renderCell: baseCell
    },
    {
      field: 'initial_discounted_units',
      headerName: t(`entities.contract_line.initial_discounted_units`),
      align: 'center',
      filterOperators: numberFilterOperators,
      width: 150,
      //editable: true,
      renderCell: baseCell
    },
    {
      field: 'available_discounted_units',
      headerName: t(`entities.contract_line.available_discounted_units`),
      align: 'center',
      filterOperators: numberFilterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      width: 200,
      filterOperators,
      valueGetter: (params) => params.value?.code ?? params.value,
      renderCell: (params: GridRenderCellParams) => {
        return <DataGridCell content={params.value} />;
      }
    },
    {
      field: '',
      width: 100,
      type: 'actions',
      getActions: (params: GridRowParams) => {
        if (!disableEdit) {
          return [
            <GridActionsCellItem
              key={1}
              label={t('actions.edit')}
              icon={<EditIcon />}
              onClick={() => handleEdit(params.row)}
            />,
            <ConfirmationDeleteTableDialog
              key={2}
              id={params.row['id']}
              handleDelete={handleManualDelete}
            />
          ];
        } else {
          return [];
        }
      }
    }
  ];

  return columns;
}
